import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import InputField from "../Components/InputField";
import Dropdown from "../Components/Dropdown";
import { getBRBDDirectors } from "../Api/BRBD";
import { useAuth } from "../Context/AuthContext";
import { Base_URL  } from "../url";
import axios from "axios";
import { toast } from "react-toastify";
import ViewBrBDDocuments from "./ViewBRBDDocuments";
const BRBD = ({ selectedType, statementId,statement,selectedCurrency }) => {
  const { user } = useAuth();
const [showViewModal, setShowViewModal] = useState(false);
  const [head3, setHead3] = useState("");
  const [head2, setHead2] = useState("");
  const[remarks,setRemarks]=useState("");
  const [directors, setDirectors] = useState([]);
  const [selectedDirector, setSelectedDirector] = useState("");
  useEffect(() => {
    const loadDirectors = async () => {
      try {
        const res = await getBRBDDirectors(
          user?.organisationId?.toString()
        );
        setDirectors(res || []);
      } catch (err) {
        console.error("Error fetching directors", err);
      }
    };

    loadDirectors();
  }, [user?.organisationId]);

  const handleSubmit = async () => {
    const paylod={
      brbdHead1: selectedType,
      brbdHead2: head2,
      brbdHead3: head3,
      directorGuid: selectedDirector,
      docfy: statement.valueDate.split("-")[0], // Extract year from date
      brbdAmount: parseFloat(statement.transactionAmount),
      brbdCurrency: selectedCurrency,
      brbdDocumentType:selectedType,
      organisationId: user?.organisationId?.toString(),
      brbdremarks:remarks,
      statementId: statementId
    };
    const res=await axios.post(`${Base_URL}/BRBD/InsertIntoBrbd/${user?.userId?.toString()}`,paylod);
    if(res.status===204)
    {
        toast.success("BRBD entry created successfully for statement!",`${statementId}`);
    }
    else
    {
        toast.error("Failed to create BRBD entry for statement!",`${statementId}`);
    }
  };

  return (
    <div className="mt-4 p-3 border rounded">
        <Row>
            <Col>
            <Button variant="primary" onClick={() => setShowViewModal(true)}>
      View Documents
    </Button>
            </Col>
        </Row>
      <Row className="mb-3">
        {/* <Col md={3}>
          <strong>Head 1:</strong> {selectedType}
        </Col> */}
        
  <Col md={3}>
    <Dropdown
      label="Head 2"
      options={[
        { label: "FromDirector", value: "FromDirector" },
        { label: "FromCustomer", value: "FromCustomer" },
      ]}
      value={head2}
      onChange={(e) => setHead2(e.target.value)}
      optionLabel="label"
      optionValue="value"
    />
  </Col>
    <Col md={3}>
          <Dropdown
            label="Head 3"
            options={directors}
            value={head3}
            onChange={(e) => setHead3(e.target.value)}
            optionLabel="directorName"     // adjust based on API
            optionValue="directorMasterGuid"       // adjust based on API
          />
        </Col>
        <Col md={3}>
          <InputField
            label="Remarks"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </Col>
       
    
      
      </Row>
      <Row>
            <Col md={4} >
             <Button variant="success" onClick={handleSubmit}>
        Submit
        </Button></Col>
      </Row>
  <ViewBrBDDocuments
  show={showViewModal}
  handleClose={() => setShowViewModal(false)}
/>
    </div>
  );
};

export default BRBD;